import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling

export default function tooltip(node: HTMLElement, params: any): SvelteActionReturnType {
	if (!tippy) return;

	const label = node.getAttribute('aria-label');
	const content = String(label);

	if (!label) node.setAttribute('aria-label', content);

	let tooltipTemplate;

	if (params.tooltipTemplate) {
		tooltipTemplate = params.tooltipTemplate;
	} else if (params.header) {
		tooltipTemplate = `
		<div class="flex gap-2">
			<img src="info_grey.png" alt="info" class="w-4 h-4" />
			<div
				class="text-fx-pink text-xs font-medium mb-2"
			>
            ${params.header}
			</div>
		</div>
		<div
			class="text-fx-grey-300 text-xs max-w-sm"
		>
        ${params.title}
		</div>
    `;
	} else {
		tooltipTemplate = `
		<div
			class="text-fx-grey-300 text-xs max-w-sm"
		>
        ${params.title}
		</div>
    `;
	}

	const tip = tippy(node, {
		theme: !params.tooltipTemplate ? 'tooltip' : 'no-padding',
		content: tooltipTemplate,
		allowHTML: true,
		...params
	});

	return {
		update: () =>
			tip.setProps({
				content,
				...params
			}),

		destroy: () => tip.destroy()
	};
}
